import { ResultItem } from '../ResultItem/ResultItem';
import './SearchResult.css';

export const SearchResult = (props) => {
  const { result } = props;

  return (
    <div className="search-result">
      <div className="search-result__list">
        {result[0]
          ? result.map((room, i) => {
              return <ResultItem room={room} key={i} />;
            })
          : null}
      </div>
    </div>
  );
};
